import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-headline">
            Ready to Unlock Your Full Potential?
          </h2>
          <p className="cta-subheadline">
            Stop settling for generic programs and inconsistent results. 
            Get a customized training plan designed specifically for your body, goals, and lifestyle.
          </p>
          
          <div className="cta-benefits">
            <div className="benefit-item">
              <CheckCircle size={24} />
              <span>Free Initial Consultation</span>
            </div>
            <div className="benefit-item">
              <CheckCircle size={24} />
              <span>Personalized Assessment</span>
            </div>
            <div className="benefit-item">
              <CheckCircle size={24} />
              <span>Custom Program Design</span>
            </div>
          </div>

          <Link to="/schedule" className="btn-cta">
            Book Your Free Consultation
            <ArrowRight size={20} style={{ marginLeft: '8px' }} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
